import { inviteAuthReturnPath, inviteRegistrationAgentRid, readInviteContext } from "./DDZInvite";
import { hasRoomInviteFields, roomInviteHomePath, ROOM_INVITE_REGISTRY } from "./RoomInvite";

function returnSearch(backTo) {
  if (typeof backTo !== "string") return "";
  try { return new URL(backTo, "https://room-invite.invalid").search; } catch (_) { return ""; }
}

export function roomInviteAuthReturnPath(backTo, registry = ROOM_INVITE_REGISTRY) {
  if (readInviteContext(returnSearch(backTo))) return inviteAuthReturnPath(backTo);
  if (typeof backTo !== "string" || !backTo.startsWith("/home?")) return null;
  try {
    const url = new URL(backTo, "https://room-invite.invalid");
    if (url.origin !== "https://room-invite.invalid" || url.pathname !== "/home" || url.href.includes("#")) return null;
    return roomInviteHomePath(url.search, registry, true);
  } catch (_) { return null; }
}

export function roomInviteRegistrationAgentRid(backTo, storedAgentRid, registry = ROOM_INVITE_REGISTRY) {
  const search = returnSearch(backTo);
  if (readInviteContext(search)) return inviteRegistrationAgentRid(backTo, storedAgentRid);
  const home = roomInviteAuthReturnPath(backTo, registry);
  if (home) return new URLSearchParams(home.split("?")[1]).get("aid") || "";
  if (hasRoomInviteFields(search, registry)) return "";
  return storedAgentRid || "";
}
